<template>
  <InsightCard
    title="Top Converting Keywords"
    column1="Keyword"
    column2="Share"
    column3="Conversions"
    apiUrl="/google-ads-insights/keyword-level-conversions"
    :displayIndex="index"
    :formatter="formatNumber"
    :change="3"
    srcName="gads"
  />
</template>

<script setup>
import { formatNumber } from '@/utils/helperFunctions';
import InsightCard from '@/components/InsightCard.vue';

const index = [0, 1];
</script>
